// src/NationalSymbols.js

import React, { useState } from 'react';
import './NationalSymbols.css';

const countryData = {

    "USA": {
      bird: "Bald Eagle",
      birdImportance: "Symbolizes freedom and strength.",
      animal: "American Bison",
      animalImportance: "Represents the country's wildlife heritage.",
      tree: "Oak Tree",
      treeImportance: "Symbol of strength and endurance.",
      flag: "Stars and Stripes",
      flagImportance: "Represents the country's unity, history, and values."
    },
    "India": {
      bird: "Indian Peafowl (Peacock)",
      birdImportance: "Symbolizes grace, beauty, and vibrancy.",
      animal: "Bengal Tiger",
      animalImportance: "Represents power and strength.",
      tree: "Banyan Tree",
      treeImportance: "Symbol of eternal life and longevity.",
      flag: "Tricolor (Tiranga)",
      flagImportance: "Represents India's diversity and unity, with saffron, white, and green colors and the Ashoka Chakra."
    },
    "Japan": {
      bird: "Green Pheasant",
      birdImportance: "Symbol of prosperity and happiness.",
      animal: "Japanese Macaque",
      animalImportance: "Represents the country's wildlife.",
      tree: "Japanese Cherry (Sakura)",
      treeImportance: "Symbolizes the beauty and ephemeral nature of life.",
      flag: "Nisshōki (Hinomaru)",
      flagImportance: "Represents the sun and Japan's rich cultural history."
    },
    "United Kingdom": {
      bird: "European Robin",
      birdImportance: "Symbol of comfort, joy, and simplicity.",
      animal: "Lion",
      animalImportance: "Represents strength, courage, and nobility.",
      tree: "Oak Tree",
      treeImportance: "Symbol of strength and endurance.",
      flag: "Union Jack",
      flagImportance: "Represents the union of England, Scotland, and Ireland."
    },
    "Australia": {
      bird: "Emu",
      birdImportance: "Represents the unique wildlife of Australia.",
      animal: "Red Kangaroo",
      animalImportance: "Symbolizes progress and movement forward.",
      tree: "Golden Wattle",
      treeImportance: "Represents unity and resilience.",
      flag: "Australian Flag",
      flagImportance: "Represents Australia's history, culture, and unity under the Union Jack, the Commonwealth Star, and the Southern Cross."
    },
    "China": {
      bird: "Red-crowned Crane",
      birdImportance: "Symbolizes longevity and nobility.",
      animal: "Giant Panda",
      animalImportance: "Represents peace and friendship.",
      tree: "Ginkgo",
      treeImportance: "Symbolizes resilience and longevity.",
      flag: "Five-star Red Flag",
      flagImportance: "Represents the unity of the Chinese people and their country's sovereignty."
    },
    "Germany": {
      bird: "Golden Eagle",
      birdImportance: "Symbolizes strength and freedom.",
      animal: "Bundesadler (Federal Eagle)",
      animalImportance: "Represents power and history.",
      tree: "Oak",
      treeImportance: "Symbolizes strength and endurance.",
      flag: "Tricolour (Black, Red, and Gold)",
      flagImportance: "Represents freedom and unity."
    },
    "Canada": {
      bird: "Common Loon",
      birdImportance: "Represents the wilderness and natural beauty of Canada.",
      animal: "Beaver",
      animalImportance: "Symbolizes hard work and perseverance.",
      tree: "Maple",
      treeImportance: "Represents Canada’s nature and the iconic maple leaf symbol.",
      flag: "Maple Leaf Flag",
      flagImportance: "Represents unity, peace, and the natural beauty of Canada."
    },
    "Italy": {
      bird: "Italian Sparrow",
      birdImportance: "Represents Italy’s natural heritage.",
      animal: "Italian Wolf",
      animalImportance: "Symbolizes strength and freedom.",
      tree: "Olive Tree",
      treeImportance: "Represents peace and longevity.",
      flag: "Il Tricolore",
      flagImportance: "Represents hope, faith, and charity."
    },
    "South Africa": {
      bird: "Blue Crane",
      birdImportance: "Symbolizes grace and beauty.",
      animal: "Springbok",
      animalImportance: "Represents agility and vitality.",
      tree: "Real Yellowwood",
      treeImportance: "Represents heritage and endurance.",
      flag: "Rainbow Flag",
      flagImportance: "Represents unity and diversity."
    },
    "Brazil": {
      bird: "Rufous-bellied Thrush",
      birdImportance: "Represents the rich biodiversity of Brazil.",
      animal: "Jaguar",
      animalImportance: "Symbolizes power and the country's wildlife heritage.",
      tree: "Pau-brasil (Brazilwood)",
      treeImportance: "Represents the country’s historical link to the Brazilwood tree.",
      flag: "Auriverde",
      flagImportance: "Represents Brazil's natural resources and its vibrant culture."
    },
    "France": {
      bird: "Gallic Rooster",
      birdImportance: "Symbolizes courage and vigilance.",
      animal: "Gallic Rooster (Unofficial)",
      animalImportance: "Represents France's rural roots and fighting spirit.",
      tree: "Oak",
      treeImportance: "Symbolizes strength and wisdom.",
      flag: "Tricolore",
      flagImportance: "Represents liberty, equality, and fraternity."
    },
    "Russia": {
      bird: "Double-headed Eagle",
      birdImportance: "Symbolizes the country’s rich history and power.",
      animal: "Brown Bear",
      animalImportance: "Represents strength and bravery.",
      tree: "Siberian Pine",
      treeImportance: "Symbolizes endurance and resilience.",
      flag: "Tricolor Flag",
      flagImportance: "Represents the country’s historical and cultural heritage."
    },
    "Mexico": {
      bird: "Golden Eagle",
      birdImportance: "Symbolizes the country's Aztec heritage and strength.",
      animal: "Jaguar",
      animalImportance: "Represents power and the country's biodiversity.",
      tree: "Ahuehuete (Montezuma Cypress)",
      treeImportance: "Symbolizes longevity and stability.",
      flag: "Tricolor (Green, White, and Red)",
      flagImportance: "Represents hope, purity, and the blood of national heroes."
    },
    "Kenya": {
      bird: "Lilac-breasted Roller",
      birdImportance: "Represents the vibrant and diverse wildlife of Kenya.",
      animal: "Lion",
      animalImportance: "Symbolizes strength, courage, and majesty.",
      tree: "Acacia",
      treeImportance: "Represents resilience and the African savannah.",
      flag: "Maasai Shield and Spears",
      flagImportance: "Represents the struggle for freedom and the cultural heritage."
    },
    "Egypt": {
      bird: "Steppe Eagle",
      birdImportance: "Represents the power and heritage of the country.",
      animal: "Saladin Eagle",
      animalImportance: "Symbol of power and national pride.",
      tree: "Date Palm",
      treeImportance: "Symbolizes prosperity and sustenance.",
      flag: "Tricolor (Red, White, and Black)",
      flagImportance: "Represents the revolution, peace, and the people’s power."
    },
    "Argentina": {
      bird: "Rufous Hornero",
      birdImportance: "Represents the country's cultural heritage and natural beauty.",
      animal: "Cougar",
      animalImportance: "Symbolizes strength and adaptability.",
      tree: "Ceibo",
      treeImportance: "Symbolizes beauty and national pride.",
      flag: "Sun of May",
      flagImportance: "Represents the country's independence and freedom."
    },
    "South Korea": {
      bird: "Korean Magpie",
      birdImportance: "Symbolizes good fortune and happiness.",
      animal: "Siberian Tiger",
      animalImportance: "Represents bravery and strength.",
      tree: "Korean Pine",
      treeImportance: "Symbolizes peace and perseverance.",
      flag: "Taegeukgi",
      flagImportance: "Represents balance, harmony, and the universe."
    },
    
  
  // Add more countries as needed
};



const NationalSymbols = () => {
  const [selectedCountry, setSelectedCountry] = useState('USA');
  const [readAloud, setReadAloud] = useState(false);

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
  };

  const handleReadAloud = () => {
    const utterance = new SpeechSynthesisUtterance(
      `In ${selectedCountry}: The national bird is ${countryData[selectedCountry].bird}, ${countryData[selectedCountry].birdImportance}. The national animal is ${countryData[selectedCountry].animal}, ${countryData[selectedCountry].animalImportance}. The national tree is ${countryData[selectedCountry].tree}, ${countryData[selectedCountry].treeImportance}. The national flag is ${countryData[selectedCountry].flag}, ${countryData[selectedCountry].flagImportance}.`
    );
    speechSynthesis.speak(utterance);
    setReadAloud(true);
  };

  return (
    <div className="national-symbols">
      <h1>National Bird, Animal, Tree and Flag details</h1>
      <div>
        <label>
          Select Country:
          <select value={selectedCountry} onChange={handleCountryChange}>
            {Object.keys(countryData).map((country) => (
              <option key={country} value={country}>{country}</option>
            ))}
          </select>
        </label>
      </div>
      <div className="symbol-info">
        <h2>{selectedCountry}</h2>
        <p><strong>National Bird:</strong> {countryData[selectedCountry].bird}</p>
        <p>{countryData[selectedCountry].birdImportance}</p>
        <p><strong>National Animal:</strong> {countryData[selectedCountry].animal}</p>
        <p>{countryData[selectedCountry].animalImportance}</p>
        <p><strong>National Tree:</strong> {countryData[selectedCountry].tree}</p>
        <p>{countryData[selectedCountry].treeImportance}</p>
        <p><strong>National Flag:</strong> {countryData[selectedCountry].flag}</p>
        <p>{countryData[selectedCountry].flagImportance}</p>
      </div>
      <button onClick={handleReadAloud}>Read Aloud</button>
    </div>
  );
};

export default NationalSymbols;
